/**
 * Type scale. The family is the platform system font by design — a custom typeface
 * is a brand decision, and brand is deferred. `System` resolves to San Francisco on
 * iOS and Roboto on Android, which is also the fastest possible first paint because
 * nothing has to load.
 *
 * Sizes are unitless; line heights are absolute rather than multipliers, because
 * React Native's `lineHeight` takes a number and a multiplier would have to be
 * resolved at every call site.
 */
export const fontFamily = {
    sans: 'System',
    mono: 'Menlo',
};
export const fontSize = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
    '4xl': 36,
    '5xl': 48,
};
/** Paired with fontSize by key. Tighter as the size grows, which is how type works. */
export const lineHeight = {
    xs: 16,
    sm: 20,
    md: 24,
    lg: 28,
    xl: 28,
    '2xl': 32,
    '3xl': 36,
    '4xl': 40,
    '5xl': 52,
};
/** Numeric so both platforms accept it directly; React Native wants strings for some. */
export const fontWeight = {
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
};
export const letterSpacing = {
    tight: -0.4,
    normal: 0,
    wide: 0.4,
};
//# sourceMappingURL=typography.js.map